import { Grid, TextField } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { Button } from "../ui/button";

const LocationPicker = ({ setLatLang, latLang, setLocation, location }: any) => {
    // const [coordinates, setCoordinates] = useState<{ lat: number | null; lng: number | null }>({ lat: null, lng: null });
    const inputRef = useRef<any>(null);
    const autocompleteRef = useRef<any>(null);
    const mapRef = useRef<google.maps.Map | null>(null);
    const markerRef = useRef<google.maps.Marker | null>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = location || "";
        }
    }, [location]);

    useEffect(() => {
        if (!window.google) return;

        // Initialize Google Places Autocomplete
        autocompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            { types: ["geocode"] }
        );

        autocompleteRef.current.addListener("place_changed", () => {
            const place = autocompleteRef.current.getPlace();
            if (place.geometry) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();

                const coords = { lat, lng };
                // setCoordinates(coords);
                setLatLang([lng,lat]);

                if (place.formatted_address) {
                    setLocation(place.formatted_address);
                }

                updateMap(coords);
            }
        });

        return () => {
            if (autocompleteRef.current) {
                window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
            }
        };
    }, [setLatLang, setLocation]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setLocation(newValue); // Allow manual edits to update the location
    };

    useEffect(() => {
        if (latLang[0] && latLang[1]) {
            updateMap({ lng: latLang[0], lat: latLang[1] });
        }
    }, [latLang]);

    const updateMap = (coords: { lat: number; lng: number }) => {
        if (!coords.lat || !coords.lng) return;

        // Create map if not already
        if (!mapRef.current) {
            mapRef.current = new google.maps.Map(
                document.getElementById("previewMap") as HTMLElement,
                {
                    center: coords,
                    zoom: 15,
                }
            );
        }

        // Update or create marker
        if (!markerRef.current) {
            markerRef.current = new google.maps.Marker({
                position: coords,
                map: mapRef.current,
                draggable: true, // ✅ allow dragging
            });

            // When marker is dragged, update coords
            markerRef.current.addListener("dragend", (e: any) => {
                const newLat = e.latLng.lat();
                const newLng = e.latLng.lng();
                // setCoordinates({ lat: newLat, lng: newLng });
                setLatLang([newLng ,newLat]);
            });
        } else {
            markerRef.current.setPosition(coords);
        }

        // Pan map
        mapRef.current.panTo(coords);
    };

    return (
        <div style={{ textAlign: "center" }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 10 }}>
                    <TextField
                        value={location}
                        inputRef={inputRef}
                        fullWidth
                        label="Search Location"
                        variant="outlined"
                        onChange={handleInputChange}
                        size="small"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}>
                    <Button
                        type="button"
                        onClick={() => {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition((pos) => {
                                    const lat = pos.coords.latitude;
                                    const lng = pos.coords.longitude;
                                    const coords = { lat, lng };

                                    setLatLang([lng, lat]);
                                    // setCoordinates(coords);
                                    setLocation("My Current Location");
                                    updateMap(coords);
                                });
                            }
                        }}
                    >
                        Use my location
                    </Button>
                </Grid>
            </Grid>

            <div
                id="previewMap"
                style={{
                    width: "100%",
                    height: "400px",
                    margin: "auto",
                    borderRadius: "10px",
                    border: "1px solid #ccc",
                    marginTop: "10px",
                }}
            />
        </div>
    );
};

export default LocationPicker;
